export const PLAYER_VERSION = 'main';
